import { Outlet, useNavigate } from "react-router-dom";
import { Header } from "../header/Header";
import Style from "./index.module.css";

export const LayoutWithHeader = () => {
    const navigate = useNavigate();

    return (
        <div className={Style.layoutHeader}>
            <Header navigate={navigate} />

            <main className={Style.mainContent}>
                <Outlet />
            </main>
        </div>
    );
};
